// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audit_title[data-v-344f6d36] {\n  font-weight: bold;\n  margin-bottom: 20px;\n  font-size: 16px;\n}\n.audit_textarea[data-v-344f6d36] {\n  margin-top: 10px;\n}\n.audit_textarea[data-v-344f6d36] .el-textarea__inner {\n    margin-top: 13px;\n    height: 132px;\n}\n", ""]);
// Exports
module.exports = exports;
